import {useState} from "react";
import "../../css/modal/LessonModal.css";
import LessonModifyModal from "../modal/LessonModifyModal";

let LessonCell = (props) => {
    let [modalOpen, setModalOpen] = useState(false)
    let onCellClick = (_) => {
        if (props.isAdmin || (props.lesson.userid === props.myInformation.userid))
            setModalOpen(true)
    }
    let onCloseClick = (_) => {
        setModalOpen(false);
    }
    let isDuePassed = () => {
        let date = new Date();
        let due = new Date(props.lesson.due);
        due.setHours(props.lesson.hour);
        return date.getTime() >= due.getTime()
    }
    let getStatusClass = () => {
        if (props.lesson.is_done) {
            if (!isDuePassed())
                return "table-cell-abnormally-cancelled"
            return "table-cell-done"
        }
        if (props.lesson.is_grand) {
            return "table-cell-reservation-grand"
        }
        return "table-cell-reservation"
    }

    return (<>
        <div className={"table-main-cell table-cell-lesson " + getStatusClass()} onClick={onCellClick}>
            <p>{props.lesson.username}</p>
        </div>
        <LessonModifyModal opened={modalOpen} lesson={props.lesson} data={props.data}
                           onCloseClick={onCloseClick.bind(this)} needUpdate={props.needUpdate}
                           setNeedUpdate={props.setNeedUpdate} isAdmin={props.isAdmin}
                           setNeedInfoRefresh={props.setNeedInfoRefresh}
        ></LessonModifyModal>
    </>)
}
export default LessonCell;